/**
 * FET (Frozen Embryo Transfer) Monitoring API Endpoints
 * Base URL: /api/v1/embryo-fet-monitorings
 */

export class EmbryoFetMonitoringAPI {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  /**
   * Create new FET Monitoring Record
   * POST /api/v1/embryo-fet-monitorings/:procedureId
   */
  async createFetMonitoring(procedureId, payload) {
    return this.apiClient.post(
      `/api/v1/embryo-fet-monitorings/${procedureId}`,
      {
        monitoring: payload.monitoring || payload,
        records: payload.records || [],
        acceptabilities: payload.acceptabilities || [],
      },
    );
  }

  /**
   * Get FET Monitoring by ID
   * GET /api/v1/embryo-fet-monitorings/:monitoringId
   */
  async getFetMonitoring(monitoringId) {
    return this.apiClient.get(
      `/api/v1/embryo-fet-monitorings/${monitoringId}`,
    );
  }

  /**
   * Get all FET Monitorings for a Procedure
   * GET /api/v1/embryo-fet-monitorings/procedure/:procedureId
   */
  async getFetMonitoringsByProcedure(procedureId) {
    return this.apiClient.get(
      `/api/v1/embryo-fet-monitorings/procedure/${procedureId}`,
    );
  }

  /**
   * Get FET Monitoring Parameter Group
   * GET /api/v1/ivf/fet-monitoring/params
   */
  async getFetMonitoringParameterGroup() {
    return this.apiClient.get('/api/v1/ivf/fet-monitoring/params');
  }

  /**
   * Update FET Monitoring
   * PUT /api/v1/embryo-fet-monitorings/:monitoringId
   * Note: Backend expects monitoring data in the request body
   */
  async updateFetMonitoring(monitoringId, payload) {
    return this.apiClient.put(
      `/api/v1/embryo-fet-monitorings/${monitoringId}`,
      {
        monitoring: payload,
      },
    );
  }

  /**
   * Update FET Monitoring Records
   * PUT /api/v1/embryo-fet-monitorings/:monitoringId/records
   */
  async updateFetMonitoringRecords(monitoringId, recordsData) {
    return this.apiClient.put(
      `/api/v1/embryo-fet-monitorings/${monitoringId}/records`,
      {
        records: recordsData,
      },
    );
  }

  /**
   * Update Endometrial Acceptabilities
   * PUT /api/v1/embryo-fet-monitorings/:monitoringId/acceptabilities
   */
  async updateEndometrialAcceptabilities(monitoringId, acceptabilitiesData) {
    return this.apiClient.put(
      `/api/v1/embryo-fet-monitorings/${monitoringId}/acceptabilities`,
      {
        acceptabilities: acceptabilitiesData,
      },
    );
  }

  /**
   * Get Endometrial Acceptabilities
   * GET /api/v1/embryo-fet-monitorings/:monitoringId/acceptabilities
   */
  async getEndometrialAcceptabilities(monitoringId) {
    return this.apiClient.get(
      `/api/v1/embryo-fet-monitorings/${monitoringId}/acceptabilities`,
    );
  }

  /**
   * Delete FET Monitoring
   * DELETE /api/v1/embryo-fet-monitorings/:monitoringId
   */
  async deleteFetMonitoring(monitoringId) {
    return this.apiClient.delete(
      `/api/v1/embryo-fet-monitorings/${monitoringId}`,
    );
  }
}
